import { render, staticRenderFns } from "./UiToastList.vue?vue&type=template&id=183c589c&scoped=true&"
import script from "./UiToastList.vue?vue&type=script&lang=js&"
export * from "./UiToastList.vue?vue&type=script&lang=js&"
import style0 from "./UiToastList.vue?vue&type=style&index=0&id=183c589c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183c589c",
  null
  
)

export default component.exports